import { SearchTypeListKey } from 'src/constants/shipmentTracking';

export const STATUS_DATA = (newShipmentView) => ([{
  key: 'TOTAL_COUNT',
  label: 'Total',
  color: '#218EE9',
},
...(newShipmentView ? [{
  key: 'PRE_TRACKING_COUNT',
  label: 'Pre Tracking',
  color: '#824DB2',
}]: []),
{
  key: 'AT_ORIGIN',
  label: 'At Origin',
  color: '#824DB2',
}, {
  key: 'IN_TRANSIT',
  label: 'In Transit',
  color: '#4469AF',
}, {
  key: 'TRANSSHIPMENT',
  label: 'Transshipment',
  color: '#C353AB',
}, {
  key: 'REACHED_DESTINATION_PORT',
  label: 'Reached Destination',
  color: '#43B131',
}, {
  key: 'COMPLETE',
  label: 'Completed',
  color: '#8DA0C7',
}, {
  key: 'DELAYED',
  label: 'Delayed',
  color: '#E94A41',
}, {
  key: 'ON_HOLD',
  label: 'On Hold',
  color: '#DFC12F',
}]);

export const SORT_BY_OPTIONS = {
  BL : [{
    id: 'updatedAt',
    name: 'Creation Date',
  }, {
    id: 'lastSuccessfulTrackingStatusUpdatedAt',
    name: 'Last Tracking Time',
  }, {
    id: 'lastActivityUpdatedAt',
    name: 'Last Activity Updated',
  }, {
    id: 'finalEta',
    name: 'Final ETA',
  },  {
    id: 'pgiDate',
    name: 'PGI Date',
  }],
  HBL : [{
    id: 'updatedAt',
    name: 'Creation Date',
  }, {
    id: 'lastSuccessfulTrackingStatusUpdatedAt',
    name: 'Last Tracking Time',
  }, {
    id: 'lastActivityUpdatedAt',
    name: 'Last Activity Updated',
  }, {
    id: 'finalEta',
    name: 'Final ETA',
  },  {
    id: 'pgiDate',
    name: 'PGI Date',
  }],
  CONTAINER : [{
    id: 'addedAt',
    name: 'Creation Date',
  }, {
    id: 'lastSuccessfulTrackingStatusUpdatedAt',
    name: 'Last Tracking Time',
  }, {
    id: 'lastActivityUpdatedAt',
    name: 'Last Activity Updated',
  }, {
    id: 'finalEta',
    name: 'Final ETA',
  }, {
    id: 'pgiDate',
    name: 'PGI Date',
  }],
  SHIPMENT : [{
    id: 'updatedAt',
    name: 'Creation Date',
  }, {
    id: 'lastSuccessfulTrackingStatusUpdatedAt',
    name: 'Last Tracking Time',
  }, {
    id: 'lastActivityUpdatedAt',
    name: 'Last Activity Updated',
  }, {
    id: 'finalEta',
    name: 'Final ETA',
  }, {
    id: 'pgiDate',
    name: 'PGI Date',
  }],
};

export const TAB_ID = {
  SHIPMENT : 'SHIPMENT',
  BL : 'BL',
  CONTAINER : 'CONTAINER',
};

export enum viewToggle {
  MAP = 'MAP',
  LIST = 'LIST',
}

export const EVENT_TYPE = {
  ALL : 'ALL',
  SHIPMENT : 'SHIPMENT',
  NON_SHIPMENT : 'NONSHIPMENT'
}

export const SHIPMENT_TYPE = {
  BL : 'BL',
  HBL: 'HBL',
  CONTAINER : 'CONTAINER',
  CN: 'CN',
  SHIPMENT: 'SHIPMENT',
  BK: 'BK',
  AWB: 'AWB',
};

export const getDefaultSearchType = (tabId: string): SearchTypeListKey => {
  switch (tabId) {
    case SHIPMENT_TYPE.CONTAINER: return SearchTypeListKey.ContainerId;
    case SHIPMENT_TYPE.HBL: return SearchTypeListKey.HblId;
    default: return SearchTypeListKey.BlId;
  }
};

export const STATUS_LABELS = {
  DELAYED: 'Delayed',
  ON_TIME: 'On Time',
  ARRIVING_EARLY: 'Early Arrival',
  COMPLETE: 'Reached POD',
  REACHED_DESTINATION_PORT: 'Reached POD',
  AT_ORIGIN : 'At Origin',
  IN_TRANSIT: 'In Transit',
  TRANSSHIPMENT: 'Transshipment',
};

export const STATUS_LABELS_TIME_KEYS = {
  DELAYED: 'DELAYED',
  ON_TIME: 'ON_TIME',
  ARRIVING_EARLY: 'ARRIVING_EARLY',
  REACHED_DESTINATION_PORT: 'REACHED_DESTINATION_PORT',
}


export const STATUS_LABELS_LOCATION_KEYS = {
  REACHED_DESTINATION_PORT: 'REACHED_DESTINATION_PORT',
  AT_ORIGIN : 'AT_ORIGIN',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSSHIPMENT: 'TRANSSHIPMENT',
}

export const INSIGHTS_FILTERS = {
  DEMURRAGE_DAYS: [{
    key: 'isGateOutPending',
    label: 'Gate Out Pending',
  }, {
    key: 'isGatedOut',
    label: 'Gated Out',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  DETENTION_DAYS: [{
    key: 'isContainerReturnPending',
    label: 'Container Return Pending',
  }, {
    key: 'isContainersReturned',
    label: 'Containers Returned',
  }],
  ON_TIME_PERFORMANCE: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  VOLUME_ANALYSIS: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  CUSTOMER_WISE_ON_TIME_PERFORMANCE: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  CUSTOMER_WISE_VOLUME_ANALYSIS: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  PROMISE_ADHERENCE_ABSOLUTE: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
  VESSEL_DEPARTURE: [{
    key: 'isActive',
    label: 'Active',
  }, {
    key: 'isCompleted',
    label: 'Completed',
  }],
};

export const INSIGHTS_RADIO_FILTERS = {
  trackingType: [{
    key: 'SHIPMENT',
    label: 'Shipment',
  }, {
    key: 'HBL',
    label: 'HBL',
  }],
};

export const SHIPMENT_KEY_MAPPINGS = {
  SHIPMENT: {
    refreshRequestedAt: 'refreshRequestedAt',
    disableRefreshRequest: 'disableRefreshRequest',
    shipmentNumber: 'shipmentNumber',
    trackingFetchFailureMessage: 'trackingFetchFailureMessage',
    infoFetchFailureMessage: 'infoFetchFailureMessage',
    isTrackingPresent: 'isTrackingPresent',
    isTrackingFailed: 'isTrackingFailed',
    reachedDestinationAt: 'reachedDestinationAt',
    routeFrom: 'containerTrackingShipment',
  },
  BL: {
    refreshRequestedAt: 'refreshBlInfoRequestedAt',
    disableRefreshRequest: 'disableRefreshBlInfoRequest',
    shipmentNumber: 'blNumber',
    trackingFetchFailureMessage: 'infoFetchFailureMessage',
    isTrackingPresent: 'isInfoPresent',
    isTrackingFailed: 'isInfoFetchFailed',
    reachedDestinationAt: 'containerReachedDestinationAt',
    routeFrom: 'containerTrackingBL',
  },
  HBL: {
    refreshRequestedAt: 'refreshBlInfoRequestedAt',
    disableRefreshRequest: 'disableRefreshBlInfoRequest',
    shipmentNumber: 'hblNumber',
    trackingFetchFailureMessage: 'infoFetchFailureMessage',
    isTrackingPresent: 'isInfoPresent',
    isTrackingFailed: 'isInfoFetchFailed',
    reachedDestinationAt: 'containerReachedDestinationAt',
    routeFrom: 'containerTrackingHBL',
  },
  BK: {
    refreshRequestedAt: 'refreshBlInfoRequestedAt',
    disableRefreshRequest: 'disableRefreshBlInfoRequest',
    shipmentNumber: 'bookingNumber',
    trackingFetchFailureMessage: 'infoFetchFailureMessage',
    isTrackingPresent: 'isInfoPresent',
    isTrackingFailed: 'isInfoFetchFailed',
    reachedDestinationAt: 'containerReachedDestinationAt',
    routeFrom: 'containerTrackingBL',
  },
  CONTAINER: {
    refreshRequestedAt: 'refreshContainerTrackingRequestedAt',
    disableRefreshRequest: 'disableRefreshContainerTrackingRequest',
    shipmentNumber: 'containerNumber',
    trackingFetchFailureMessage: 'trackingFetchFailureMessage',
    isTrackingPresent: 'isTrackingPresent',
    isTrackingFailed: 'isTrackingFailed',
    reachedDestinationAt: 'reachedDestinationAt',
    routeFrom: 'containerTrackingContainer',
  },
};

export const MOVEMENT_TYPES = {
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  TRADE: 'TRADE',
};

export const ENTITIES = {
  SUPPLIER: 'SUPPLIER',
  CUSTOMER: 'CUSTOMER',
  SHIPPER: 'SHIPPER',
  FF: 'FF',
};

export const isMarkAsCompleteAllowed = (permissions) => {
  return permissions.write || permissions.delete;
};

export const COLOR_MAPPING_MOVEMENT_TYPE = {
  EXPORT: '#F87B1B',
  IMPORT: '#9B25E9',
  TRADE: '#E50375',
};

export const TEAMS_TYPE = {
  TEAM :'Team',
  PRIVATE : 'Private',
  PUBLIC :'Workplace',
};

export const TEAM_ICONS = {
  TEAM :'team',
  PRIVATE : 'lock',
  PUBLIC : 'global',
};

export const ACCESS_TYPE_TEXT = {
  PRIVATE : 'Shipments with private access will only be visible to you and the admin',
  PUBLIC : 'Shipments with workplace access will be visible to all the users of the organization',
  TEAM : 'Shipments with team access will be visible only to the admins and members of the selected team',
};

export const STATUS_KEYS = {
  AT_ORIGIN : 'AT_ORIGIN',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSSHIPMENT: 'TRANSSHIPMENT',
  REACHED_DESTINATION_PORT: 'REACHED_DESTINATION_PORT',
  DELAYED: 'DELAYED',
};

export const DateFilterTypes = {
  reached_destination_at: 'Reached Destination at',
  created_at: 'Date of Creation',
  pgi_date:  'Date of PGI (Post good issue)'
}

export const advisoryTableColumnHeaders = {
  sNo: 'S.N.',
  carrierName: 'Shipping Line',
  successPercent: 'Success Rate',
  reason: 'Reason',
  estimatedResolutionDays: 'Expected Resolution Time'
};

export enum summaryDashboardBreakdown {
  AT_ORIGIN = 'At Origin',
  IN_TRANSIT = 'In Transit',
  TRANSSHIPMENT = 'Transshipment',
  REACHED_POD = 'Reached POD',
};

export enum summaryDashboardChartLegends {
  '> 3 Days Delayed' = 'DELAY_GREATER_THAN_THREE_DAYS',
  '1 - 3 Days Delayed' = 'DELAY_UP_TO_THREE_DAYS',
  'On Time' = 'ON_TIME',
  'Arriving early' = 'EARLY_ARRIVAL'
};
